import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <select
      className="nav-lang-select"
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      defaultValue={i18n.language.startsWith("en") ? "en" : "fr"}
    >
      <option value="fr">🇫🇷</option>
      <option value="en">🇺🇸</option>
    </select>
  );
};

export default LanguageSwitcher;
